import { InjectionToken } from '@angular/core';
import { IAuthService } from '../interfaces/auth-service';

export const AUTH_SERVICE = new InjectionToken<IAuthService>('AUTH_SERVICE');
